import actions from './actions/actions'
import mutations from './mutations/mutation'
const state = {
  edishow:true,
  bdis: localStorage.getItem('presellconfig')&&localStorage.getItem('presellconfig')!='null'?JSON.parse(localStorage.getItem('presellconfig')).bdis:0, //后续分销
  exptypes: '', //快递方式
  cardRule: { // 券卡规则信息存储
    cardkind: '', // 券卡类型
    cardprice: "", // 券卡面值
    cardsmallprice: "", // 券卡售价
    discount: "", //折扣
    selnum: 1, // 可选择商品数量
    selzones: 1, // 专区数量
    defaultgoodscode: '', // 默认商品的规格编号
    defaultgoodsname: '', // 默认商品的名称
    usenum: 1, // 券卡使用次数
    areainfo:[], // 专区设置信息
    arrylist:[],//专区一的商品
    startvaldate: '', // 起始有效期
    endvaldate: '', // 结束有效期
    bmodify: 0, // 券卡是否级联修改
    cardcategory: false, //按量提货
    tcCardcategory: false,//套餐组合提货卡
    deCardcategory: false,//定额组合提货卡
    goodspicknum: 1, // 商品可兑换总数
    minpicknumonce: 1, // 单次最少提货数
  },
  isHelp:true,//是否打开了帮助文档
  isQKchild:false,//基座：false  子项目：true
  updateSkin:localStorage.getItem('storeskinthemecolor') && localStorage.getItem('storeskinthemecolor') != 'undefined' && localStorage.getItem('storeskinthemecolor') != 'null'?Number(localStorage.getItem('storeskinthemecolor')):0,//皮肤 0:橙色 1：蓝色 2：绿色
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/common/common.js